export default {
  name: 'MobileView',
  computed: {
    showMobileView() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return true;
        case 'lg':
        case 'xl':
          return false;
      }
      return true;
    },
    textStyle() {
      if (this.$vuetify.theme.currentTheme.primary !== '#FFFFFF') {
        return 'white--text';
      }
      return 'black--text';
    },
  },
};
